import 'svelte/internal/disclose-version';

ReviewCard[$.FILENAME] = 'src/components/ReviewCard.svelte';

import * as $ from 'svelte/internal/client';
import Avatar from "./Avatar.svelte";
import Stars from "./Stars.svelte";
import { relativeTime } from "../lib/format.js";

var root = $.add_locations($.from_html(`<button type="button" class="remove svelte-1xhx1zi">Remove</button>`), ReviewCard[$.FILENAME], [[16, 8]]);
var root_1 = $.add_locations($.from_html(`<h4 class="svelte-1xhx1zi"> </h4>`), ReviewCard[$.FILENAME], [[20, 22]]);
var root_2 = $.add_locations($.from_html(`<p class="svelte-1xhx1zi"> </p>`), ReviewCard[$.FILENAME], [[21, 21]]);
var root_3 = $.add_locations($.from_html(`<article class="review svelte-1xhx1zi"><!> <div class="body svelte-1xhx1zi"><div class="head svelte-1xhx1zi"><strong class="svelte-1xhx1zi"> </strong> <time class="svelte-1xhx1zi"> </time> <!></div> <!> <!> <!></div></article>`), ReviewCard[$.FILENAME], [[9, 0, [[11, 2, [[12, 4, [[13, 6], [14, 6]]]]]]]]);

const $$css = {
	hash: 'svelte-1xhx1zi',
	code: '\n  .review.svelte-1xhx1zi {\n    display: flex;\n    gap: 14px;\n    padding: 18px 0;\n    border-bottom: 1px solid var(--line);\n  }\n  .review.svelte-1xhx1zi:last-child { border-bottom: none; }\n  .body.svelte-1xhx1zi { flex: 1; display: flex; flex-direction: column; gap: 5px; min-width: 0; }\n  .head.svelte-1xhx1zi { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }\n  strong.svelte-1xhx1zi { font-size: 0.94rem; }\n  time.svelte-1xhx1zi { font-size: 0.8rem; color: var(--ink-faint); }\n  .remove.svelte-1xhx1zi {\n    margin-left: auto;\n    border: none;\n    background: none;\n    color: var(--ink-faint);\n    font-size: 0.8rem;\n    cursor: pointer;\n  }\n  .remove.svelte-1xhx1zi:hover { color: var(--accent); text-decoration: underline; }\n  h4.svelte-1xhx1zi { margin: 3px 0 0; font-size: 1rem; font-family: var(--font); }\n  p.svelte-1xhx1zi { margin: 0; line-height: 1.6; color: var(--ink-soft); font-size: 0.93rem; white-space: pre-wrap; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function ReviewCard($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, ReviewCard);
	$.append_styles($$anchor, $$css);

	let canDelete = $.prop($$props, 'canDelete', 3, false),
		ondelete = $.prop($$props, 'ondelete', 3, null);

	var $$exports = { ...$.legacy_api() };
	var article = root_3();
	var node = $.child(article);

	$.add_svelte_meta(
		() => Avatar(node, {
			get name() {
				return $$props.review.authorName;
			},
			size: 40
		}),
		'component',
		ReviewCard,
		10,
		2,
		{ componentTag: 'Avatar' }
	);

	var div = $.sibling(node, 2);
	var div_1 = $.child(div);
	var strong = $.child(div_1);
	var text = $.child(strong, true);

	$.reset(strong);

	var time = $.sibling(strong, 2);
	var text_1 = $.child(time, true);

	$.reset(time);

	var node_1 = $.sibling(time, 2);

	{
		var consequent = ($$anchor) => {
			var button = root();

			$.delegated('click', button, function click() {
				return ondelete()?.($$props.review);
			});

			$.append($$anchor, button);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if (canDelete()) $$render(consequent);
			}),
			'if',
			ReviewCard,
			15,
			6
		);
	}

	$.reset(div_1);

	var node_2 = $.sibling(div_1, 2);

	$.add_svelte_meta(
		() => Stars(node_2, {
			get value() {
				return $$props.review.rating;
			},
			size: 15,
			showNumber: false
		}),
		'component',
		ReviewCard,
		19,
		4,
		{ componentTag: 'Stars' }
	);

	var node_3 = $.sibling(node_2, 2);

	{
		var consequent_1 = ($$anchor) => {
			var h4 = root_1();
			var text_2 = $.child(h4, true);

			$.reset(h4);
			$.template_effect(() => $.set_text(text_2, $$props.review.title));
			$.append($$anchor, h4);
		};

		$.add_svelte_meta(
			() => $.if(node_3, ($$render) => {
				if ($$props.review.title) $$render(consequent_1);
			}),
			'if',
			ReviewCard,
			20,
			4
		);
	}

	var node_4 = $.sibling(node_3, 2);

	{
		var consequent_2 = ($$anchor) => {
			var p = root_2();
			var text_3 = $.child(p, true);

			$.reset(p);
			$.template_effect(() => $.set_text(text_3, $$props.review.body));
			$.append($$anchor, p);
		};

		$.add_svelte_meta(
			() => $.if(node_4, ($$render) => {
				if ($$props.review.body) $$render(consequent_2);
			}),
			'if',
			ReviewCard,
			21,
			4
		);
	}

	$.reset(div);
	$.reset(article);

	$.template_effect(
		($0) => {
			$.set_text(text, $$props.review.authorName);
			$.set_attribute(time, 'datetime', $$props.review.createdAt);
			$.set_text(text_1, $0);
		},
		[() => relativeTime($$props.review.createdAt)]
	);

	$.append($$anchor, article);

	return $.pop($$exports);
}

$.delegate(['click']);